import V2aScreen from 'features/v2a/sender/screens/V2aScreen';
import React from 'react';

export default function Page() {
  return <V2aScreen />;
}
